
  import payment from '~/mixins/pages/deposit/payment'

  export default {
    mixins: [payment],
    layout: 'blank'
  }
